// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const PageSlicer = require('client-v2/common/components/page-slicer')
const { createFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')
// Entry imports
const discoverActions = require('./actions')
const DiscoverSection = require('./component-dumb')
const discoverSelectors = require('./selectors')

const commonSmartFeed = createFeedSmartComponent(discoverActions, discoverSelectors)

const PAGE_SIZE = 15

function mapStateToProps(state, props) {
  const commonProps = commonSmartFeed.mapStateToProps(state)
  return Object.assign(commonProps, {
    // Work-around https://app.asana.com/0/102902769366319/928788517144243/f
    isCollectionSubscribersCountHidden: true,
    isHeaderVisible: props.isHeaderVisible,
    isMoreAvailable: props.isMoreAvailable && commonProps.isMoreAvailable,
    pageCount: props.pageCount,
    pageSize: PAGE_SIZE,
    pageStart: props.pageStart
  })
}

module.exports = connect(
  mapStateToProps,
  commonSmartFeed.mapDispatchToProps
)(
  PageSlicer(
    ImmutableToJS(
      DiscoverSection
    )
  )
)
